import { ShipmentAgent } from "./Shipment/ShipmentAgent";
import { ClientAgent } from "./clients/ClientAgent";
import { DedicatedDeliveryAgent } from "./dedicatedDelivery/DedicatedDeliveryAgent";
import { StoreManifestAgent } from "./dedicatedReceiving/StoreManifestAgent";
import { EventAgent } from "./event/EventAgent";
import { EventTypeAgent } from "./eventType/EventTypeAgent";
import { FdpAgent } from "./fdp/FdpAgent";
import { LoginAgent } from "./login/loginAgent";
import { MiddleMileAgent } from "./middleMile/MiddleMileAgent";
import { MissingManifestAgent } from "./missingManifest/MissingManifestAgent";
import { PackageAgent } from "./package/PackageAgent";
import { ParcelCenterAgent } from "./parcelCenter/ParcelCenterAgent";
import { ReceivingAgent } from "./receiving/ReceivingAgent";
import { ReturnToStationAgent } from "./returnToStation/ReturnToStationAgent";
import { RoleAgent } from "./role/RoleAgent";
import { UserAgent } from "./user/UserAgent";
import { ZipCoverageAgent } from "./zipCoverage/ZipCoverageAgent";
import { RatecardAgent } from "./ratecard/RatecardAgent";
import { ClientInvoiceAgent } from "./clientInvoices/ClientInvoiceAgent";
import { KnowledgehubAgent } from "./knowledgehub/KnowledgehubAgent";

const agent = {
  LoginAgent,
  ReceivingAgent,
  ReturnToStationAgent,
  ParcelCenterAgent,
  ShipmentAgent,
  MiddleMileAgent,
  EventTypeAgent,
  RoleAgent,
  ZipCoverageAgent,
  MissingManifestAgent,
  ClientAgent,
  UserAgent,
  EventAgent,
  PackageAgent,
  FdpAgent,
  DedicatedDeliveryAgent,
  RatecardAgent,
  StoreManifestAgent,
  ClientInvoiceAgent,
  KnowledgehubAgent
};

export default agent;
